import { Box, Stack, Text } from "@origin-digital/ods-core";
import React, { useContext } from "react";
import { AppContext } from "src/context/AppContext";
import { useAuth0 } from "src/hooks/useAuth";
import { ProfileMenuButton } from "../ProfileMenuButton";

export const HeaderProfile = () => {
  const { isAuthenticated } = useAuth0();
  const { context } = useContext(AppContext);

  if (!isAuthenticated) {
    return null;
  }
  return (
    <Box display="flex" alignItems="center">
      <Box paddingRight="small">
        <Stack space="none" alignX="right">
          <Text variant="body-small" weight="medium" truncate>
            {context.user?.first_name} {context.user?.last_name}
          </Text>
          <Text variant="body-small" tone="neutralLight" truncate>
            {/*Show Company name only if user role don't contain 'ORIGIN' or is home user */}
            {context.user?.role.toLowerCase().includes("origin") ||
            !context.user?.main_company
              ? ""
              : context.user?.main_company.name}
          </Text>
        </Stack>
      </Box>
      <ProfileMenuButton />
    </Box>
  );
};
